import React from 'react';

const TimestampConcept = (props) => {
  return (
    <div>
      <p className="step-p">A record of when the block was created. </p>
      <p className="step-p"> The timestamp helps to keep the blockchain in order.</p>
    </div>
  );
};

export default TimestampConcept;


// WEBPACK FOOTER //
// ./src/steps/timestamp/timestamp-concept.js